import styled from 'styled-components';

export const LoadingSVGContainer = styled('svg')`
  position: absolute;
`;
